var _effectorFileName = "/builds/gmini/front-sm-api-sdk/src/UserClassifierRepo/UserClassifierGroup/UserClassifierGroupSource.ts";
import * as t from 'io-ts';
import { Id } from '../../Id';
import { Version } from '../../Version';
import { SourceRelationType } from '../../SourceProps';
export var UserClassifierGroupSource = t.type({
  sourceClassifierId: Id,
  sourceClassifierVersion: Version,
  sourceGroupId: Id,
  relationType: SourceRelationType
}, 'UserClassifierGroupSource');